export enum UserActionsEnum {
  LOGIN = 'LOGIN',
  EMAIL_QUOTE_OPEN = 'EMAIL_QUOTE_OPEN',
  EMAIL_QUOTE_DECLINE_OPEN = 'EMAIL_QUOTE_DECLINE_OPEN',
}
